import { useEffect, useState } from 'react';
import financeService from '../services/financeService';
import { ApprovalRule } from '../types/finance';

/**
 * The school's one approval rule, for every screen with an Approve button.
 * `ownBlocked(isOwn)` says whether this person must leave their own item to
 * someone else — true while the rule is still loading, so nothing is offered
 * that the server would refuse.
 */
export const useApprovalRule = () => {
  const [rule, setRule] = useState<ApprovalRule | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    financeService.getApprovalRule()
      .then(r => { if (live) setRule(r); })
      .catch((e: any) => { if (live) setError(e?.message || 'Could not load the approval rule.'); });
    return () => { live = false; };
  }, []);

  return { rule, error, ownBlocked: (isOwn: boolean) => isOwn && rule?.secondPerson !== false };
};
